const landing_page = {
  aboutUs: "Over ons", // translated
  topPackages: "Toppakketten", // translated
  featuredHotels: "Aanbevolen hotels", // translated
  topTours: "Toptours", // translated
  whatOurMembersSay: "Wat onze leden zeggen...", // translated
  followUsOnInstagram: "Volg ons op Instagram", // translated
  pleaseWait: "Even geduld aub...", // translated
  packages: "Pakketjes", // translated
  trustedCarHirePartners: "Betrouwbare autoverhuurpartners", // translated
  learnMore: "Kom meer te weten", // translated
  ourPartners: "Onze partners", // translated
};


export default landing_page;
